import { Button } from 'antd'

import { useFeedback } from '@eastcoal/common/hooks/useFeedback'

import { RechargeDescription } from '@eastcoal/shared/components/RechargeDescription'

export const AccountStatisticRechargeButton = () => {
  const { modal } = useFeedback()

  const handleClick = () => {
    modal.info({
      title: '入金流程',
      styles: {
        container: {
          width: 520
        }
      },
      content: <RechargeDescription />
    })
  }

  return (
    <Button ghost size='small' type='default' onClick={handleClick}>
      入金
    </Button>
  )
}
